export default __webpack_public_path__ + "static/media/LogoSTI.375e9ddb.png";